module.exports = __webpack_public_path__ + "img/furniture-en.7f1dfd8a.svg";